var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy"},[_c('span',{staticClass:"copy-icon",on:{"click":function($event){$event.stopPropagation();return _vm.copy.apply(null, arguments)},"mouseover":_vm.reset}},[_c('BaseTooltip',{attrs:{"top":"","mdi-icon":"","icon":"mdi-content-copy"}},[_vm._v(" "+_vm._s(_vm.tooltipText)+" ")])],1),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }